import React, { useEffect, useState } from 'react';

import './ProjectHeaderInfo.scss';

import { useTranslation } from 'react-i18next';
import Row from '../../Layout/Row/Row';
import {
  getDateDifferenceFromPastUtc,
  getFriendlyDuration,
  getTimezoneName,
  getFriendlyDate,
} from '../../../helpers/dateFormatHelper/dateFormatHelper';
import moment from 'moment';
import useProject from '../../../hooks/useProject';

const ProjectHeaderInfo = () => {
  const [friendlyStartsDuration, setFriendlyStartsDuration] = useState<string>('');
  const { t } = useTranslation();
  const { project } = useProject();
  const friendlyDuration = getFriendlyDuration(project?.scheduledDuration ?? 0);
  const friendlyStartDate = getFriendlyDate(project?.scheduledDateTime);

  useEffect(() => {
    const updateFriendlyStartsDuration = () => {
      if (project?.broadcastStartedUtc) {
        if (!project?.broadcastEndedUtc) {
          const dateMoment = moment.duration(getDateDifferenceFromPastUtc(project?.broadcastStartedUtc));
          setFriendlyStartsDuration(getFriendlyDuration(dateMoment.asSeconds(), true));
        } else {
          setFriendlyStartsDuration(t('project.status-ended'));
        }
      } else {
        setFriendlyStartsDuration("~");
      }
    };
    const interval = setInterval(() => updateFriendlyStartsDuration(), 10000);
    updateFriendlyStartsDuration();
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project]);


  return (
    <div className="project-header-info">
      <div className="project-header-info-block">
        <Row
          left={t('project.time-zone')}
          right={getTimezoneName(
            project?.scheduledDateTime || new Date(),
            project?.scheduledTime || '00:00:00',
            project?.scheduledTimeZone,
          )}
          columnClass="project-header-info-column"
          leftClass="project-header-info-row-title"
          rightClass="project-header-info-row-content"
        />
        <Row
          left={t('project.scheduled-for')}
          right={friendlyStartDate}
          columnClass="project-header-info-column"
          leftClass="project-header-info-row-title"
          rightClass="project-header-info-row-content"
        />
        <Row
          left={t('project.duration')}
          right={friendlyDuration}
          columnClass="project-header-info-column"
          leftClass="project-header-info-row-title"
          rightClass="project-header-info-row-content"
        />
        <Row
          left={t('project.elapsed-time')}
          right={friendlyStartsDuration}
          columnClass="project-header-info-column"
          leftClass="project-header-info-row-title"
          rightClass="project-header-info-row-content"
        />
      </div>
    </div>
  );
};

export default ProjectHeaderInfo;
